import { render, staticRenderFns } from "./zjjn1.vue?vue&type=template&id=2af62a83&scoped=true&"
import script from "./zjjn1.vue?vue&type=script&lang=js&"
export * from "./zjjn1.vue?vue&type=script&lang=js&"
import style0 from "./zjjn1.vue?vue&type=style&index=0&id=2af62a83&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af62a83",
  null
  
)

export default component.exports